"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SeoBlockTypes;
(function (SeoBlockTypes) {
    SeoBlockTypes["ExpertOpinion"] = "expertOpinion";
    SeoBlockTypes["TopOffers"] = "topOffers";
    SeoBlockTypes["FAQ"] = "faq";
    SeoBlockTypes["Html"] = "html";
    SeoBlockTypes["Review"] = "review";
    SeoBlockTypes["BestProduct"] = "bestproduct";
    SeoBlockTypes["Banner"] = "seoBanner";
    SeoBlockTypes["Tags"] = "tags";
    /** @deprecated */
    SeoBlockTypes["Chart"] = "chart";
    /** @deprecated */
    SeoBlockTypes["News"] = "news";
    /** @deprecated */
    SeoBlockTypes["Video"] = "video";
    /** @deprecated */
    SeoBlockTypes["QNA"] = "qna";
    /** @deprecated */
    SeoBlockTypes["Rating"] = "rating";
    /** @deprecated */
    SeoBlockTypes["LastOrder"] = "lastorder";
})(SeoBlockTypes || (SeoBlockTypes = {}));
exports.default = SeoBlockTypes;
